import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=6a4cd522&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4cd522')) {
      api.createRecord('6a4cd522', component.options)
    } else {
      api.reload('6a4cd522', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=6a4cd522&", function () {
      api.rerender('6a4cd522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/comments/Comment.vue"
export default component.exports